// extracted by mini-css-extract-plugin
module.exports = {"amount":"style_amount__1FInF"};